import api from './api';

export const getTerminalModels = async () => (await api.get('/admin/terminal-models')).data;

export const createTerminalModel = async (payload) => (
    await api.post('/admin/terminal-models', payload)
).data;

export const assignTerminalModel = async (serialNumber, terminalModelId) => (
    await api.put(`/admin/terminals/${encodeURIComponent(serialNumber)}/model`, {
        terminal_model_id: Number(terminalModelId)
    })
).data;
